import fetch from './fetch'

export function getCoupon (code: string, plan_id: number): Promise<api.EmptyResponse> {
  return fetch.patch(`/coupons/${code}/apply/${plan_id}`).then(res => res.data)
}
